export const LIST_ROLES = {
    list: {
        parent: 'list',
        child: 'listitem',
        supportsInteraction: false,
        supportsSelection: false,
    },
    navigation: {
        parent: 'navigation',
        child: 'link',
        supportsInteraction: false,
        supportsSelection: false,
    },
    selection: {
        parent: 'listbox',
        child: 'option',
        supportsInteraction: true,
        supportsSelection: true,
    },
} as const;
